import getCustomAxios from "../Helpers/customAxios";
import { camelizeKeys, decamelizeKeys, decamelize } from "humps";
import {
  RHEA_CMS_PROMO_CODES_API_ENDPOINT,
  RHEA_CMS_PROMO_CODES_USERS_API_ENDPOINT,
  RHEA_CMS_PROMO_CODE_API_ENDPOINT,
} from "../Constants/API";

export function getPromoCodeListAPI(
  filtersMap = new Map(),
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  // The following code will generate the query parameters for the url based on the map.
  let aURL = RHEA_CMS_PROMO_CODES_API_ENDPOINT;
  filtersMap?.forEach((value, key) => {
    // let decamelizedkey = decamelize(key);
    if (aURL.indexOf("?") > -1) {
      aURL += "&" + key + "=" + value;
    } else {
      aURL += "?" + key + "=" + value;
    }
  });

  axios
    .get(aURL)
    .then((successResponse) => {
      const responseData = successResponse.data.items;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function getPromoCodeUsersListAPI(
  filtersMap = new Map(),
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  let aURL = RHEA_CMS_PROMO_CODES_USERS_API_ENDPOINT;
  filtersMap?.forEach((value, key) => {
     
    if (aURL.indexOf("?") > -1) {
      aURL += "&" + key + "=" + value;
    } else {
      aURL += "?" + key + "=" + value;
    }
  });

  axios
    .get(aURL)
    .then((successResponse) => {
      const responseData = successResponse.data.items;

      const data = camelizeKeys(responseData);

      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function postPromoCodeCreateAPI(
  data,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  // Minor formatting to support API.
  //   data.userId = data.userID;
  //   data.no = parseInt(data.no);
  //   data.duration = parseInt(data.duration);
  //   data.targetHeartRate = parseFloat(data.targetHeartRate);
  //   data.targetHeartRateRatio = parseFloat(data.targetHeartRateRatio);

  // To Snake-case for API from camel-case in React.
  //   let decamelizedData = decamelizeKeys(data);

  axios
    .post(RHEA_CMS_PROMO_CODES_API_ENDPOINT, data)
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Minor formatting to support API.
      data.userID = data.userId;

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function getPromoCodeDetailAPI(
  sessionTemplateID,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();
  axios
    .get(RHEA_CMS_PROMO_CODE_API_ENDPOINT.replace("{id}", sessionTemplateID))
    .then((successResponse) => {
      const responseData = successResponse.data.data;

      // Return the callback data.
      onSuccessCallback(responseData);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function putPromoCodeUpdateAPI(
  data,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();

  // Minor formatting to support API.
  data.userId = data.userID;
  data.no = parseInt(data.no);
  data.duration = parseInt(data.duration);
  data.targetHeartRate = parseFloat(data.targetHeartRate);
  data.targetHeartRateRatio = parseFloat(data.targetHeartRateRatio);

  // To Snake-case for API from camel-case in React.
  let decamelizedData = decamelizeKeys(data);

  axios
    .put(
      RHEA_CMS_PROMO_CODE_API_ENDPOINT.replace("{id}", decamelizedData.id),
      decamelizedData
    )
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Minor formatting to support API.
      data.userID = data.userId;

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}

export function deletePromoCodeAPI(
  id,
  onSuccessCallback,
  onErrorCallback,
  onDoneCallback
) {
  const axios = getCustomAxios();
  axios
    .delete(RHEA_CMS_PROMO_CODE_API_ENDPOINT.replace("{id}", id))
    .then((successResponse) => {
      const responseData = successResponse.data;

      // Snake-case from API to camel-case for React.
      const data = camelizeKeys(responseData);

      // Return the callback data.
      onSuccessCallback(data);
    })
    .catch((exception) => {
      let errors = camelizeKeys(exception);
      onErrorCallback(errors);
    })
    .then(onDoneCallback);
}
